
<template>
    <!-- SHOPPING PRODUCT SELECTOR  -->
    <div class='shopping-products-chooser row'>
        <div class="col-12">
        <!-- <code>{{getSublevel(event)}}</code> -->
                <b-list-group>
                <div v-for="info in getSublevel(event)" class="">
                   
               
                    <!-- if have product - show it -->
                    <div v-if="info.productid">
                            <product-selector :productId="info.productid"></product-selector> 
                    </div>

                    <!--  if not show subtre -->
                    <div v-else>
                        <b-list-group-item class='mb-1 px-2 px-sm-3'>
                        <collapse class='event-tree-item ' :arrow='true' >
                            <div slot="header">
                               <div class='row mt-2 mb-2'>
                                    <div class="col-12 ph-2">
                                        <h3 class='mb-0 mt-0'> 
                                          
                                            <span class='pl-2 dib'> {{ info.name }} </span> </h3>
                                    </div>
                                </div>
                            </div>
                            <div class='ph-4'>
                                <products-chooser v-if="info.enabled" :event="info"></products-chooser>
                                <!-- <event-product v-if="info.product" :product="info.product"></event-product> -->
                            </div>     
                        </collapse>
                    </b-list-group-item>       
                    </div>   
                </div>
                </b-list-group>
        </div>
        <div class='col-3'>
        
        </div>
    </div>

</template>

<script>
export default {
      data(){
        return {
            open:false
        }
    },
    
    props:{
        event:{
            default:()=>{name:""}
        }
    },

     methods:{
        getSublevel:function(){
            // return _.get(this.event,'competitions[0]')
             var elements = [];

            _.each(['competitions','categories','subcategories'], k=>{
                var sublevel = _.get(this.event,k);
                if(sublevel){
                    elements = _.map(sublevel, sublevelElement=>{
                        sublevelElement.as = 'event-'+k;
                        return sublevelElement
                    })
                }
            })
            return elements

        }
    }

}
</script>

<style>

</style>
